import { Scene } from "phaser";

import { GButton } from "../gameobjects/GButton";
import { combinations} from '../utils';

// The HUD scene is the scene that shows the points and the remaining time.
export class QuickPickSceneDesktop extends Scene {
    
    constructor() {
        super("QuickPickSceneDesktop");

    }

    init(data) {
        //this.cameras.main.fadeIn(500, 0, 0, 0);
        const { min, max, ticketPrice, minNumber, maxNumber } = data;
        this.minPickNumber = min
        this.maxPickNumber = max
        this.totalPicked = this.minPickNumber;
        
        this.ticketValue = ticketPrice
        this.totalAmount = parseFloat(combinations(this.totalPicked, this.minPickNumber)*this.ticketValue).toFixed(2);
        this.currency = "$"    
        this.minNumber = minNumber;
        this.maxNumber = maxNumber;

        this.totalTicketsPicked = 1;

    }

    create() {

        // Create a transparent input zone that covers the entire screen
        this.inputZone = this.add.zone(0, 0, this.scale.width, this.scale.height)
        .setOrigin(0)
        .setInteractive(); // Make it interactive to capture clicks
          
        //this.userNameText = this.add.text(this.scale.width/2, this.scale.width/2, `QuickPickScene`).setOrigin(0.5);
        this.cameras.main.setBackgroundColor('rgba(21, 21, 21, 0.85)');

        this.graphics = this.add.graphics();

        this.graphics.fillStyle(0x05022D, 1);

        this.graphics.fillRoundedRect(this.scale.width/2 - 343/2,this.scale.height/2 - 514/2, 343 , 514, 32);


        this.title = this.add.text(this.scale.width/2, 78, `QUICK PICK`,  { fontFamily: 'Oswald', fontSize: 24, color: '#ffffff' }).setOrigin(0.5);
        this.title.setFontStyle('700')


        const ButtonCancel = new GButton( this, this.scale.width/2-80, 500, {
            texturePack: "pack", 
            idleTexture: 'Button - Secondary - Default.png',
            clickedTexture: 'Button - Secondary - Clicked.png',
            disabledTexture: 'Button - Secondary - Disabled.png',
            text: {
                value:'CANCEL',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            onClick: () => {
                //console.log('Button ButtonQuickPick!');
                this.scene.stop()
                //this.scene.resume("BuyTicketScene" , {})
                
                //this.scene.launch("QuickPickScene")
             }
        });

        ButtonCancel.setScale(0.44);

        const ButtonConfirm = new GButton( this,this.scale.width/2+80, 500, {
            texturePack: "pack", 
            idleTexture: 'Button - Primary - Default.png',
            clickedTexture: 'Button - Secondary - Clicked.png',
            disabledTexture: 'Button - Secondary - Disabled.png',
            text: {
                value:'CONFIRM',
                style:  { fontFamily: 'Oswald', fontSize: 32, color: '#ffffff' }
            },
            onClick: () => {
                //console.log('Button ButtonQuickPick!');
                const totalPrice = +this.registry.get('cart_amount') + +this.totalAmount;
                this.registry.set('cart_amount', totalPrice);

                let currentCatItem = this.registry.get('cart_items')
                
                //const ticketPrice = this.totalAmount / this.totalTicketsPicked;
                const ticketPrice = parseFloat(combinations(this.totalPicked, this.minPickNumber)*this.ticketValue).toFixed(2);

                for (let i = 0; i < this.totalTicketsPicked; i++) {
                    const  selectedNumbers = this.getRandomUniqueNumbers(this.minNumber, this.maxNumber, this.totalPicked)
                    
                    currentCatItem.push({
                        selectedNumbers: selectedNumbers,
                        totalAmount: ticketPrice,
                        numberCount: this.totalPicked
                    });
                }

                this.registry.set('cart_items', currentCatItem);

                //console.log("currentCatItem", currentCatItem)

                this.scene.stop()
                this.scene.start("BuyTicketSceneDesktop")
                
                //this.scene.launch("QuickPickScene")
             }
        });
    
        ButtonConfirm.setScale(0.44);



        this.ButtonTicketPlus = new GButton( this, this.scale.width/2 + 130, 170, {
            texturePack: "pack", 
            idleTexture: 'qty-Default.png',
            clickedTexture: 'qty-Pressed.png',
            disabledTexture: 'qty-Disabled.png',
            icon: {
                image: "plus-icon.png",
                scale: 2
            },
            onClick: () => {
                this.incrementTicket();
             }
        });
    
        this.ButtonTicketPlus.setScale(0.5);


        this.ButtonTicketMinus = new GButton( this,  this.scale.width/2 - 130, 170, {
            texturePack: "pack", 
            idleTexture: 'qty-Default.png',
            clickedTexture: 'qty-Pressed.png',
            disabledTexture: 'qty-Disabled.png',
            icon: {
                image: "minus-icon.png",
                scale: 0.75
            },
            onClick: () => {
                this.decrementTicket()
             }
        });
    
        this.ButtonTicketMinus.setScale(0.5);
        this.ButtonTicketMinus.setDisabled();







        this.ButtonPlus = new GButton( this, this.scale.width/2 + 130, 290, {
            texturePack: "pack", 
            idleTexture: 'qty-Default.png',
            clickedTexture: 'qty-Pressed.png',
            disabledTexture: 'qty-Disabled.png',
            icon: {
                image: "plus-icon.png",
                scale: 2
            },
            onClick: () => {
                this.incrementNumber();
             }
        });
    
        this.ButtonPlus.setScale(0.5);


        this.ButtonMinus = new GButton( this,  this.scale.width/2 - 130, 290, {
            texturePack: "pack", 
            idleTexture: 'qty-Default.png',
            clickedTexture: 'qty-Pressed.png',
            disabledTexture: 'qty-Disabled.png',
            icon: {
                image: "minus-icon.png",
                scale: 0.75
            },
            onClick: () => {
                this.decrementNumber()
             }
        });
    
        this.ButtonMinus.setScale(0.5);
        this.ButtonMinus.setDisabled();



        this.NumberTicketInputTitle = this.add.text(this.scale.width/2,  120, `Number of Tickets:` ,  { fontFamily: 'Montserrat', fontSize: 16, color: '#ffffff' }).setOrigin(0.5);
        this.NumberTicketInputTitle.setFontStyle('500')

        this.NumberTicketBackground = this.add.nineslice(this.scale.width/2,  170, 'pack', 'Slider-Base.png', 175*2, 104, 32, 32);
        this.NumberTicketBackground.setScale(0.5);

        this.totalTicketsText = this.add.text(this.scale.width/2,  170, this.totalTicketsPicked ,  { fontFamily: 'Oswald', fontSize: 20, color: '#ffffff' }).setOrigin(0.5);
        this.totalTicketsText.setFontStyle('700')


        this.PickerInputTitle = this.add.text(this.scale.width/2, 240, `Numbers To Pick:` ,  { fontFamily: 'Montserrat', fontSize: 16, color: '#ffffff' }).setOrigin(0.5);
        this.PickerInputTitle.setFontStyle('500')


        this.TicketPickerBackground = this.add.nineslice(this.scale.width/2,  290, 'pack', 'Slider-Base.png', 175*2, 104, 32, 32);
        this.TicketPickerBackground.setScale(0.5);

        
        this.totalPickedText = this.add.text(this.scale.width/2,  290, this.totalPicked ,  { fontFamily: 'Oswald', fontSize: 20, color: '#ffffff' }).setOrigin(0.5);
        this.totalPickedText.setFontStyle('700')



        this.PickerInputTitle = this.add.text(this.scale.width/2,  370, `Ticket Cost:` ,  { fontFamily: 'Montserrat', fontSize: 16, color: '#ffffff' }).setOrigin(0.5);
        this.PickerInputTitle.setFontStyle('500')


        this.TicketPriceBackground   = this.add.nineslice(this.scale.width/2,  420, 'pack', 'Slider-Base.png', 300*2, 104, 32, 32);
        this.TicketPriceBackground.setScale(0.5);

        this.totalPriceText = this.add.text(this.scale.width/2,  420, `${this.currency}${this.totalAmount}` ,  { fontFamily: 'Oswald', fontSize: 20, color: '#ffffff' }).setOrigin(0.5);
        this.totalPriceText.setFontStyle('700')


    }

    incrementTicket(){
        this.totalTicketsPicked++;
        this.totalTicketsText.setText(this.totalTicketsPicked);
        this.ButtonTicketMinus.enable();

        this.totalAmount = parseFloat(combinations(this.totalPicked, this.minPickNumber)*this.ticketValue*this.totalTicketsPicked).toFixed(2);
        this.totalPriceText.setText(`${this.currency}${this.totalAmount}`);
    }

    decrementTicket(){
        this.totalTicketsPicked--;  
        
        if(this.totalTicketsPicked == 1){
            this.ButtonTicketMinus.setDisabled();
        }
        this.totalTicketsText.setText(this.totalTicketsPicked);

        this.totalAmount = parseFloat(combinations(this.totalPicked, this.minPickNumber)*this.ticketValue*this.totalTicketsPicked).toFixed(2);
        this.totalPriceText.setText(`${this.currency}${this.totalAmount}`);
    }

    incrementNumber(){
        if(this.totalPicked < this.maxPickNumber) {
            this.totalPicked++;
            this.ButtonMinus.enable();
            this.totalPickedText.setText(this.totalPicked);


            this.totalAmount = parseFloat(combinations(this.totalPicked, this.minPickNumber)*this.ticketValue*this.totalTicketsPicked).toFixed(2);
            this.totalPriceText.setText(`${this.currency}${this.totalAmount}`);
        }

        if(this.totalPicked == this.maxPickNumber){
            this.ButtonPlus.setDisabled();
        }
    }

    decrementNumber(){
        if(this.totalPicked > this.minPickNumber) {
            this.totalPicked--;
            this.ButtonPlus.enable();
            this.totalPickedText.setText(this.totalPicked);


            this.totalAmount = parseFloat(combinations(this.totalPicked, this.minPickNumber)*this.ticketValue*this.totalTicketsPicked).toFixed(2);
            this.totalPriceText.setText(`${this.currency}${this.totalAmount}`);
        }

        if(this.totalPicked == this.minPickNumber){
            this.ButtonMinus.setDisabled();
        }
    }

    getRandomUniqueNumbers(min, max, count) {
        if (count > max - min + 1) {
            throw new Error("Count exceeds the number of available unique numbers in the range.");
        }
    
        // Create an array with all numbers in the range [min, max]
        const numbers = [];
        for (let i = min; i <= max; i++) {
            numbers.push(i);
        }
    
        // Shuffle the array using the Fisher-Yates shuffle algorithm
        for (let i = numbers.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
        }
    
        // Get the first `count` numbers from the shuffled array
        const selectedNumbers = numbers.slice(0, count);
        
        // Sort the selected numbers in ascending order
        return selectedNumbers.sort((a, b) => a - b);
    }

}